function AsyncActionModal({
  open,
  title,
  status,
  message,
  statusLabel,
  details = [],
  onClose,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary
}) {
  if (!open) return null;

  const isLoading = status === "loading";
  const isSuccess = status === "success";
  const isError = status === "error";
  const statusTitle = isLoading
    ? title
    : isSuccess
      ? title || "Success"
      : title || "Something went wrong";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[95] p-4">
      <div className="bg-white rounded-xl max-w-md w-full shadow-2xl">
        <div className="flex justify-between items-center px-6 pt-6 pb-4 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-800">{statusTitle}</h2>
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className={`w-8 h-8 flex items-center justify-center rounded-full text-lg font-bold transition-colors ${
              isLoading
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
            }`}
            aria-label="Close"
          >
            x
          </button>
        </div>

        <div className="px-6 py-8">
          <div className="flex flex-col items-center text-center mb-6">
            {isLoading && (
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-green-100 border-t-green-600 mb-5" />
            )}

            {isSuccess && (
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            )}

            {isError && (
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
            )}

            <h3 className="text-xl font-bold text-gray-800">
              {statusLabel || (isLoading ? title : isSuccess ? "Successful" : "Failed")}
            </h3>
            {message && (
              <p className={`text-sm mt-1 ${isError ? "text-red-500" : "text-gray-500"}`}>
                {message}
              </p>
            )}
          </div>

          {details.length > 0 && (
            <div className={`${isError ? "bg-red-50" : "bg-green-50"} rounded-xl p-4 space-y-3 mb-6`}>
              {details.map((detail, index) => (
                <div
                  key={`${detail.label}-${index}`}
                  className={`${index > 0 ? `border-t ${isError ? "border-red-100" : "border-green-100"} pt-3` : ""} flex justify-between items-center gap-4`}
                >
                  <span className="text-gray-500 text-sm">{detail.label}</span>
                  <span className={`font-semibold text-right ${detail.tone === "error" ? "text-red-600" : "text-gray-800"}`}>
                    {detail.value}
                  </span>
                </div>
              ))}
            </div>
          )}

          {!isLoading && (primaryLabel || secondaryLabel) && (
            <div className="flex gap-3">
              {primaryLabel && (
                <button
                  type="button"
                  onClick={onPrimary}
                  className="flex-1 bg-green-600 text-white py-2.5 px-4 rounded-lg hover:bg-green-700 transition-colors font-semibold"
                >
                  {primaryLabel}
                </button>
              )}
              {secondaryLabel && (
                <button
                  type="button"
                  onClick={onSecondary}
                  className="flex-1 bg-gray-100 text-gray-700 py-2.5 px-4 rounded-lg hover:bg-gray-200 transition-colors font-semibold"
                >
                  {secondaryLabel}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AsyncActionModal;
